import { Box, HStack, Image, Pressable, Stack, Text } from 'native-base';
import Icon from 'ui/components/Icon';
import { MenuItem } from '~/components/Layout/Drawer/types';
import { useMenuListController } from '~/components/MenuList/controller';

interface MenuListProps {
  menuItems: MenuItem[];
}

export const MenuList = ({ menuItems }: MenuListProps) => {
  const { goToRoute, getStyles } = useMenuListController();

  return (
    <Stack w="full">
      {menuItems?.length
        ? menuItems.map((item) => {
            const styles = getStyles(item.path);
            return (
              <Stack key={item.path} position="relative" mr="5">
                <Box
                  pl="-1"
                  bgColor={styles.bgColor}
                  h="45"
                  w="full"
                  top={31}
                  borderRightRadius="3xl"
                />
                <Pressable
                  onPress={() => {
                    item.customNavigationAction &&
                      item.customNavigationAction();
                    goToRoute(item.path);
                  }}
                  pl={6}
                >
                  <HStack space={2}>
                    {!item.isCustom ? (
                      <Icon icon={item.icon} color={styles.icon} size={20} />
                    ) : (
                      <Image source={{ uri: item.icon }} size={5} />
                    )}
                    <Text color={styles.text} fontSize="sm" fontWeight={500}>
                      {item.label}
                    </Text>
                  </HStack>
                </Pressable>
              </Stack>
            );
          })
        : null}
    </Stack>
  );
};

export default MenuList;
